/*
 * PRODUCT FEEDBACK (F4a) — member submissions counted by type and area. Never text, never a
 * member. Support is counted on its own and never mixed into product figures.
 */
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Inbox } from "lucide-react";
import { Panel, Note, Chip, fmt, FreshnessNote } from "./ConsolePrimitives";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/founder`;

const shown = (env) => (env?.suppressed ? "Withheld" : fmt(env?.value));

const AreaChips = ({ rows, prefix }) => (
  <div style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
    {(rows || []).map((r) => (
      <Chip key={r.area} tone="quiet" testId={`${prefix}-${r.area}`}>
        {r.area}: {r.suppressed ? "withheld" : r.count}
      </Chip>
    ))}
  </div>
);

export const ProductFeedbackView = ({ params }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/product-feedback`, { params });
      setData(res.data);
    } catch (e) {
      setError("Product feedback could not be read just now.");
    }
  }, [params]);

  useEffect(() => { load(); }, [load]);

  return (
    <>
      <header className="fc__section-head">
        <h2 data-testid="fc-product-feedback-title">Product Feedback</h2>
        <p>What members sent us, counted by type and area. No feedback text is read here.</p>
      </header>
      <Panel title="Submissions in this period" icon={Inbox} testId="fc-product-feedback-panel"
        sub={data && !data.collection_enabled ? "Collection is not enabled for members yet." : undefined}>
        <table className="fc-table">
          <thead><tr><th>Type</th><th>Count</th></tr></thead>
          <tbody>
            <tr><td><b>Product feedback</b></td><td data-testid="fc-pf-product">{shown(data?.member_feedback_product)}</td></tr>
            <tr><td><b>Feature requests</b></td><td data-testid="fc-pf-features">{shown(data?.member_feedback_feature_requests)}</td></tr>
            <tr><td><b>Support requests</b></td><td data-testid="fc-pf-support">{shown(data?.member_feedback_support)}</td></tr>
          </tbody>
        </table>
        <AreaChips rows={data?.product_feedback_by_area} prefix="fc-pf-area" />
        <AreaChips rows={data?.feature_requests_by_area} prefix="fc-fr-area" />
        {data && <Note testId="fc-pf-separation">{data.separation}</Note>}
        {error && <Note testId="fc-pf-error">{error}</Note>}
      </Panel>
      {data?.freshness && <FreshnessNote freshness={data.freshness} />}
    </>
  );
};
